export interface CopilotScopeKey {
  accountId: string;
  userId: string;
  workspaceId: string;
}

export const copilotQueryKeys = {
  all: ["copilot"] as const,
  conversation: (scope: CopilotScopeKey) =>
    ["copilot", "conversation", scope.accountId, scope.userId, scope.workspaceId] as const,
};
